export default "__VITE_ASSET__a66e92e8__"